import React from 'react';
import { Path } from 'react-native-svg';
import withDefaultIconProps from './withDefaultIconProps';
import SVGIcon from './SVGIcon';
const TableIcon = ({ color, ...rest }) => {
    return (React.createElement(SVGIcon, { ...rest },
        React.createElement(Path, { fill: "none", stroke: color, strokeWidth: 2, d: "M3.818 7.91h16.364M3.818 14.453h16.364M12 8.727v11.455M5.455 21h13.09A2.454 2.454 0 0 0 21 18.546V5.455A2.455 2.455 0 0 0 18.546 3H5.455A2.455 2.455 0 0 0 3 5.455v13.09A2.455 2.455 0 0 0 5.455 21Z" })));
};
export default withDefaultIconProps(TableIcon);
